import React from "react";
import { Plus, List } from "lucide-react";
import { PROJECT_ROLE_LABELS } from "../../../../../constants/projectRoles";

const InspectionsActionsBar = ({
  projectName,
  projectRole,
  showList,
  onToggleList,
  onToggleNew,
  searchTerm,
  onSearchChange,
}) => {
  const roleLabel = PROJECT_ROLE_LABELS[projectRole] || "Admin";
  return (
    <div className="flex items-center justify-between">
      <div className="text-sm text-gray-600">
        Project: <strong>{projectName}</strong> • Your project role:{" "}
        <strong>{roleLabel || "Admin"}</strong>
      </div>

      <div className="flex items-center gap-2">
        <input
          type="text"
          value={searchTerm || ""}
          onChange={(e) => onSearchChange?.(e.target.value)}
          placeholder="Search #, date, created by, type, location, site location, status..."
          className="w-80 max-w-full px-3 py-2 rounded-md border border-gray-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
        />
        <button
          type="button"
          onClick={onToggleNew}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-orange-500 text-white text-sm font-medium hover:bg-orange-600 transition"
        >
          <Plus className="w-4 h-4" />
          New Inspection
        </button>

        <button
          type="button"
          onClick={onToggleList}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50 transition"
        >
          <List className="w-4 h-4" />
          {showList ? "Hide List" : "List Inspections"}
        </button>
      </div>
    </div>
  );
};

export default React.memo(InspectionsActionsBar);
